import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomIsDormitoryType = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { isDormitoryType } = viewModel;

	const onSetIsDormitoryType = useCallback(
		(input: boolean) => {
			onSetViewModel([{ key: "isDormitoryType", value: { ...isDormitoryType, value: input } }]);
		},
		[isDormitoryType, onSetViewModel],
	);

	return {
		isDormitoryType,
		onSetIsDormitoryType,
	};
};
